export default {
  default: () => import("/app/app/layouts/default.vue").then(m => m.default || m)
}